<script>
  import SlideIt from "svelte-glidejs";

  let options = {
    type: "slide",
    focusAt: "center",
    direction: "ltr",
    startAt: 0,
    perView: 1,
    gap: 0,
    hoverpause: true,
    autoplay: 7000,
  };
  let listslide = [
    {
      title:
        "Welcome to <span class='font-bold'>Mikhub</span><br/>Cloud Mikrotik Manager",
      subtitle: "Hallo...",
      img: "assets/svg/ilustrations/progressive_app.svg",
    },
    {
      title: "#MikhubNetwork",
      subtitle: "Manage your network easier with Mikhub",
      img: "assets/svg/ilustrations/best_place.svg",
    },
    {
      title: "#MikhubPoints",
      subtitle:
        "Don't bother because of bills, topup points according to what you need",
      img: "assets/svg/ilustrations/online.svg",
    },
  ];
</script>

<div
  class="relative w-full overflow-hidden bg-white bg-opacity-100 shadow-2xl lg:bg-white lg:bg-opacity-75"
>
  <SlideIt {options} bullet={false} control={false} items={listslide}>
    <div
      slot="item"
      let:item
      class="w-full h-screen p-10 leading-tight text-black bg-white bg-center bg-no-repeat bg-contain shadow-lg"
      style="background-image: url('{item.img}');"
    >
      <span class="text-lg font-light">
        <div class="h-4 px-2" />
        <span class="bg-white bg-opacity-75 rounded">{item.subtitle}</span
        ></span
      >
      <div class="text-xl">
        <span class="bg-white bg-opacity-75 rounded">{@html item.title}</span>
      </div>
    </div>
  </SlideIt>
</div>
